import React from "react";
import Modal from "../../components/Modals/Modal";
import SecondaryButton from "../../components/Buttons/SecondaryButton";
import PrimaryButton from "../../components/Buttons/PrimaryButton";
import TextInput from "../../components/Inputs/TextInput";
import NumberInput from "../../components/Inputs/NumberInput";

function AddTreatmentTransactionModal({
  showAddTreatmentTransaction,
  setShowAddTreatmentTransaction,
  createTreatmentTransaction,
  treatmentId,
  updateTransactions
}) {
  const [formError, setFormError] = React.useState({
    field: "",
    msg: "",
  });

  const [newTransaction, setNewTransaction] = React.useState(
    {
      amount: null,
      payment_description: null,
      name: null
    }
  );

  const hideModal = () => {
     setNewTransaction({
      amount: null,
      payment_description: null,
      name: null,
    });
    setShowAddTreatmentTransaction(false);
  };

  const handleAddTreatmentTransaction = async () => {
    if (!newTransaction.amount) {
      return setFormError({
        field: "amount",
        msg: "Amount is missing.",
      });
    }
    if (!newTransaction.name) {
      return setFormError({
        field: "name",
        msg: "Item name is missing.",
      });
    }
    if (!newTransaction.payment_description) {
      return setFormError({
        field: "description",
        msg: "Payment description is missing.",
      });
    }

    await createTreatmentTransaction(treatmentId, newTransaction).then(res => {
      updateTransactions();
      hideModal();
    });
  };

  const handleAmountChange = (e) => {
    if (e.target.value < 0) return;
    setNewTransaction(prev => ({ ...prev, amount: e.target.value }));
  }

  return (
    <Modal
      title={"Add Treatment Transaction"}
      show={showAddTreatmentTransaction}
      hide={hideModal}
    >
      <div className="flex flex-col">
        <div className="grid grid-cols-1 mt-8">
          <TextInput 
            label='Item name'
            value={newTransaction.name}
            onChange={(e) =>
              setNewTransaction(prev => ({ ...prev, name: e.target.value }))
            }
            placeholder="Enter name"
          />
          {formError.field === "name" && (
          <span className="text-red-400 text-sm">{formError.msg}</span>
          )}
          <TextInput 
            labelClass='mt-4'
            value={newTransaction.payment_description}
            onChange={(e) =>
              setNewTransaction(prev => ({ ...prev, payment_description: e.target.value }))
            }
            rows={4}
            textArea
            placeholder="Enter description"
            label='Description'
          />
          {formError.field === "description" && (
            <span className="text-red-400 text-sm">{formError.msg}</span>
          )}
          <NumberInput 
            labelClass='mt-4'
            value={newTransaction.amount}
            onChange={handleAmountChange}
            placeholder="Enter amount"
            label='Amount (€)'
          />
          {formError.field === "amount" && (
            <span className="text-red-400 text-sm">{formError.msg}</span>
          )}
        </div>
        <div className="grid grid-cols-2 gap-x-2 mt-6">
          <SecondaryButton
            onClick={hideModal}
            text="Cancel"
          />
          <PrimaryButton
            text={"Save"}
            onClick={handleAddTreatmentTransaction}
          />
        </div>
      </div>
    </Modal>
  );
}

export default AddTreatmentTransactionModal;